import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/audit-trail/')({
  component: () => <div>Audit Trail</div>,
});
